import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeading } from "@/components/Section";
import { ConfidentialName } from "@/components/PlatformCard";

export default function CaseStudies() {
  const [platforms, setPlatforms] = useState([]);

  useEffect(() => {
    api.get("/public/platforms.json").then((r) => {
      setPlatforms([...(r.data.internal || []), ...(r.data.external || [])]);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="case-studies-page">
      <section className="section-pad border-b border-zinc-900">
        <div className="container-tib">
          <SectionHeading
            overline="Case studies"
            title="How the platforms got built."
            body="Long-form write-ups of what TIB shipped, why, and what it now runs as."
          />
        </div>
      </section>

      <section className="section-pad">
        <div className="container-tib space-y-6">
          {platforms.map((p) => (
            <Link
              key={p.slug}
              to={`/platforms/${p.slug}`}
              data-testid={`case-study-${p.slug}`}
              className="card-edge group flex flex-col md:flex-row items-stretch overflow-hidden"
            >
              <div className="md:w-72 h-48 md:h-auto relative shrink-0 overflow-hidden">
                {p.hero_image_url ? (
                  <img src={p.hero_image_url} alt={p.name} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center" style={{ backgroundImage: "radial-gradient(circle at 30% 30%, rgba(124,58,237,0.22), transparent 55%), linear-gradient(#0a0a0a,#000)" }}>
                    <img src="/tib-logo.png" alt="" className="w-16 h-16 object-contain opacity-70 mix-blend-screen" />
                  </div>
                )}
              </div>
              <div className="p-8 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-3">
                  <span className={`overline ${p.ownership === "external" ? "!text-tib-royal" : ""}`}>{p.ownership === "internal" ? "Internal" : "External"}</span>
                  <span className="text-[0.62rem] font-mono uppercase tracking-widest text-tib-gold border border-tib-gold/40 px-2 py-0.5">{p.confidential ? "confidential" : (p.status === "coming_soon" ? "coming soon" : p.status)}</span>
                </div>
                <h3 className="h-serif text-3xl text-white flex items-center gap-3">
                  {p.confidential ? <ConfidentialName name={p.name} /> : p.name} <ArrowUpRight className="w-5 h-5 text-zinc-600 group-hover:text-tib-gold transition-colors" />
                </h3>
                <p className="text-zinc-400 mt-3 leading-relaxed max-w-2xl">{p.summary || p.tagline}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
